import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds

export const useSessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId;
    let activityTimeout;

    const resetTimeout = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        localStorage.removeItem('isAuthenticated');
        navigate('/');
      }, SESSION_TIMEOUT);
    };

    const handleActivity = () => {
      // Debounce the activity handler
      if (activityTimeout) {
        clearTimeout(activityTimeout);
      }
      activityTimeout = setTimeout(resetTimeout, 1000);
    };

    // Set up event listeners for user activity
    const events = ['mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Initialize the timeout
    resetTimeout();

    // Cleanup
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (activityTimeout) {
        clearTimeout(activityTimeout);
      }
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [navigate]);
}; 